<app-openground-header
  [cloudName]="cloudName"
  [firstName]="firstName"
  [lastName]="lastName"
  [initials]="initials"
  [email]="email"
  [fullName]="fullName"
  (changeCloud)="onChangeCloud()"
  (signOff)="onSignOff()"
  [logoutVisible]="logoutEnabled"
  [changeCloudVisible]="selectCloudEnabled"
></app-openground-header>
<banner
  [visible]="cloudUnderMaintenance"
  type="error"
  [message]="cloudUnderMaintenance"
  (close)="onCloseCloudMaintenancebanner()"
></banner>
<banner
  class="banner"
  [visible]="userInActiveMessage"
  [message]="userInActiveMessage"
  (close)="onCloseInActiveUserbanner()"
  type="error"
  
></banner>
<router-outlet></router-outlet>
<app-quick-links #quickLinks class="footer"></app-quick-links>
